import { Anchor, AspectRatio, Button, Group, Image, Paper, Text } from '@mantine/core';
import { IconExternalLink, IconFileTypePdf } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { api } from '../lib/api';

function embedUrl(url: string): string | null {
  try {
    const u = new URL(url);
    if (u.hostname.endsWith('youtube.com')) {
      const id = u.searchParams.get('v');
      return id ? `https://www.youtube-nocookie.com/embed/${id}` : null;
    }
    if (u.hostname === 'youtu.be') return `https://www.youtube-nocookie.com/embed/${u.pathname.slice(1)}`;
    if (u.hostname === 'vimeo.com') return `https://player.vimeo.com/video/${u.pathname.split('/').filter(Boolean)[0]}`;
    if (u.hostname === 'player.vimeo.com') return url;
    if (u.hostname.endsWith('loom.com')) return url.replace('/share/', '/embed/');
    if (u.hostname === 'rutube.ru') {
      const id = u.pathname.split('/').filter(Boolean)[1];
      return id ? `https://rutube.ru/play/embed/${id}` : null;
    }
  } catch {
    return null;
  }
  return null;
}

export function VideoBlock({ url }: { url: string }) {
  const src = embedUrl(url);
  if (!src) return <Anchor href={url} target="_blank" rel="noopener noreferrer">Открыть видео <IconExternalLink size={14} /></Anchor>;
  return (
    <AspectRatio ratio={16 / 9}>
      <iframe src={src} title="Видео урока" allow="fullscreen; picture-in-picture" style={{ border: 0, borderRadius: 8 }} />
    </AspectRatio>
  );
}

// Файл урока скачивается с токеном и показывается из blob: прямой ссылки на хранилище нет
export function AttachmentBlock({ path, filename, mime }: { path: string; filename: string; mime: string }) {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let revoke: string | null = null;
    api.blob(path).then((b) => {
      revoke = URL.createObjectURL(b);
      setUrl(revoke);
    }).catch(() => setError(true));
    return () => {
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path]);

  if (error) return <Text c="red" size="sm">Не удалось загрузить файл {filename}</Text>;
  if (!url) return <Text c="dimmed" size="sm">Загрузка {filename}…</Text>;
  if (mime.startsWith('image/')) return <Image src={url} alt={filename} radius="md" />;
  return (
    <Paper withBorder p="sm" radius="md">
      <Group justify="space-between" mb="xs">
        <Group gap="xs"><IconFileTypePdf size={20} /><Text size="sm" fw={500}>{filename}</Text></Group>
        <Button size="xs" variant="light" component="a" href={url} target="_blank">Открыть отдельно</Button>
      </Group>
      <iframe src={url} title={filename} style={{ width: '100%', height: 520, border: 0 }} />
    </Paper>
  );
}
